(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('PaieController', PaieController);

    PaieController.$inject = ['$state', 'Paie', 'Technicien', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PaieController($state, Paie, Technicien, ParseLinks, AlertService, paginationConstants, pagingParams) {
        $(document).ready(function () {
            $('#filterTechnicien').select2();
            $('#filterTechnicien').on('select2:select', function (e) {
                vm.filterTechnicien = $('#filterTechnicien').val();
                vm.search();
            });
        });

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterDatePaie = pagingParams.datePaie;
        vm.filterDatePrime = pagingParams.datePrime;
        vm.filterTechnicien = pagingParams.technicien;

        vm.search = search;
        vm.techniciens = pagingParams.techniciens;

        vm.datePickers = {};
        vm.openCalendar = openCalendar;

        loadAll();
        loadTechniciens();

        function loadAll () {
            Paie.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                technicien: vm.filterTechnicien,
                datePrime: vm.filterDatePrime,
                datePaie: vm.filterDatePaie
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.paies = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadTechniciens(){
        	Technicien.technicienEnabled({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function openCalendar (date) {
            vm.datePickers[date] = true;
        }


        function search(){
        	vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                technicien: vm.filterTechnicien,
                datePaie: vm.filterDatePaie,
                datePrime: vm.filterDatePrime
            });
        }
    }
})();
